import { render, staticRenderFns } from "./ManufactureWhite.vue?vue&type=template&id=4ff7e148"
import script from "./ManufactureWhite.vue?vue&type=script&lang=js"
export * from "./ManufactureWhite.vue?vue&type=script&lang=js"
import style0 from "./ManufactureWhite.vue?vue&type=style&index=0&id=4ff7e148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports